import { render, staticRenderFns } from "./WithdrawInstructions.vue?vue&type=template&id=6cc15c56&scoped=true"
import script from "./WithdrawInstructions.vue?vue&type=script&lang=js"
export * from "./WithdrawInstructions.vue?vue&type=script&lang=js"
import style0 from "./WithdrawInstructions.vue?vue&type=style&index=0&id=6cc15c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc15c56",
  null
  
)

export default component.exports